import { getAuthAxiosBackend } from "../helpers/axios"

class FileServices{
    
    download(uri, data = {}, onDownloadProgress){
        data.onDownloadProgress = onDownloadProgress;
        return getAuthAxiosBackend().get(uri, data);
    }

    responseBlob(response, fileName){
        var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        return Promise.resolve(true)
    }
}

export default new FileServices()